import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "paragraphjustificationoptions"
    }}>{`ParagraphJustificationOptions`}</h1>
    <p>{`Paragraph justification.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DEFAULT_JUSTIFICATION`}</strong>{` = 1886020709`}</p>
      <p parentName="blockquote">{`Default justification`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ARABIC_JUSTIFICATION`}</strong>{` = 1886019954`}</p>
      <p parentName="blockquote">{`Arabic justification`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NASKH_JUSTIFICATION`}</strong>{` = 1886023265`}</p>
      <p parentName="blockquote">{`Naskh justification`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NASKH_TATWEEL_JUSTIFICATION`}</strong>{` = 1886023284`}</p>
      <p parentName="blockquote">{`Kashidas without Stretched Connections.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NASKH_KASHIDA_JUSTIFICATION`}</strong>{` = 1886023275`}</p>
      <p parentName="blockquote">{`Kashidas. Use naskh justification if you want to also use Justifcation Alternates.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NASKH_TATWEEL_JUSTIFICATION_FRAC`}</strong>{` = 1886021236`}</p>
      <p parentName="blockquote">{`Fractional Kashidas without Stretched Connections.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NASKH_KASHIDA_JUSTIFICATION_FRAC`}</strong>{` = 1886021227`}</p>
      <p parentName="blockquote">{`Fractional Kashidas. Use naskh justification if you want to also use Justifcation Alternates.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      